export function LangleyCTA() {
  const handleAssessment = () => {
    window.REACT_APP_NAVIGATE('/property-assessment');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    'Jurisdiction verification and zoning analysis',
    'Complete business license application management',
    'Safety inspection coordination and compliance',
    'Insurance guidance and documentation',
    'Property listing optimization and marketing',
    'Ongoing compliance monitoring and renewals'
  ];

  const contactMethods = [
    {
      icon: 'ri-phone-line',
      title: 'Call Us',
      detail: '+1 (778) 386-9229',
      action: 'tel:+17783869229'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email Us',
      detail: 'contact@furnishedrentalmanagement.com',
      action: 'mailto:contact@furnishedrentalmanagement.com'
    },
    {
      icon: 'ri-calendar-line',
      title: 'Book Consultation',
      detail: 'Free 30-min call',
      action: null
    }
  ];

  return (
    <section id="contact" className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Ready to Launch Your Langley Short-Term Rental?
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Whether you're in the Township or City of Langley, we provide complete licensing support and ongoing management to maximize your rental income while ensuring full compliance.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* Services */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="font-['Fraunces'] text-2xl font-bold text-[#505A5A] mb-6">
              Complete Langley STR Services
            </h3>
            <ul className="space-y-4">
              {services.map((service, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#882629] text-xl flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5"></i>
                  <span className="text-[#505A5A]/80">{service}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 pt-8 border-t border-[#505A5A]/10">
              <p className="text-sm text-[#505A5A]/70 leading-relaxed">
                <strong>Langley-specific expertise:</strong> We understand the nuances between Township and City regulations, zoning variations, and local market dynamics to position your property for success.
              </p>
            </div>
          </div>

          {/* Contact Methods */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="font-['Fraunces'] text-2xl font-bold text-[#505A5A] mb-6">
              Get Started Today
            </h3>
            <div className="space-y-4 mb-8">
              {contactMethods.map((method, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-4 p-4 bg-[#F0F0F0] rounded-xl hover:bg-[#882629]/5 transition-all cursor-pointer"
                  onClick={() => {
                    if (method.action) {
                      window.location.href = method.action;
                    } else {
                      scrollToContact();
                    }
                  }}
                >
                  <div className="w-12 h-12 bg-[#882629] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${method.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#505A5A] text-sm">{method.title}</p>
                    <p className="text-[#505A5A]/70">{method.detail}</p>
                  </div>
                </div>
              ))}
            </div>

            <button 
              onClick={handleAssessment}
              className="w-full bg-[#882629] text-white px-8 py-5 rounded-full text-lg font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
            >
              Request Langley Consultation
            </button>

            <p className="text-xs text-[#505A5A]/60 text-center mt-4">
              Serving both Township of Langley and City of Langley property owners
            </p>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="bg-white rounded-2xl p-8 lg:p-12">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-[#882629] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-3xl"></i>
              </div>
              <h4 className="font-['Fraunces'] text-xl font-bold text-[#505A5A] mb-2">
                100% Compliant
              </h4>
              <p className="text-sm text-[#505A5A]/70">
                Every property fully licensed and regulation-compliant
              </p>
            </div>
            <div>
              <div className="w-16 h-16 bg-[#882629] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-user-line text-white text-3xl"></i>
              </div>
              <h4 className="font-['Fraunces'] text-xl font-bold text-[#505A5A] mb-2">
                Local Experts
              </h4>
              <p className="text-sm text-[#505A5A]/70">
                Deep knowledge of Langley's unique regulatory landscape
              </p>
            </div>
            <div>
              <div className="w-16 h-16 bg-[#882629] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-white text-3xl"></i>
              </div>
              <h4 className="font-['Fraunces'] text-xl font-bold text-[#505A5A] mb-2">
                Full Support
              </h4>
              <p className="text-sm text-[#505A5A]/70">
                From licensing to daily operations and guest management
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
